export default __webpack_public_path__ + "static/media/arrow-up-right-green.66823e79.svg";